// extracted by mini-css-extract-plugin
export default {"labelText":"ConfirmCloseDialog-module__labelText__Wa_4YjD"};